import React, { useEffect, useRef } from 'react';

import { Navigate } from 'react-router-dom';

import PageLoader from 'components/PageLoader/PageLoader';
import PageTitle from 'components/PageTitle/PageTitle';
import { FEATURE_FLAGS } from 'constants/dictionaries/featureFlags';
import PATHS from 'constants/paths';
import FullScreen from 'containers/FullScreen/FullScreen';
import TablesProvider from 'context/TablesContext';
import { useUserLogContext } from 'context/UserLogContext/UserLogContext';
import useFeatureFlags from 'hooks/useFeatureFlags/useFeatureFlags';
import OnGoRouter from './_components/OnGoRouter';
import useSubjectStore from 'storages/subject';

const OnGoPage: React.FC = () => {
  const { isLoading, isEnabled } = useFeatureFlags();
  const { subject } = useSubjectStore();
  const { logEvent } = useUserLogContext();
  const hasLoggedEnter = useRef(false);

  useEffect(() => {
    if (!subject || !isEnabled(FEATURE_FLAGS.ON_GO) || hasLoggedEnter.current) {
      return;
    }
    hasLoggedEnter.current = true;
    logEvent('on-go-enter', { subjectPk: subject.pk, subjectCode: subject.subjectCode });
  }, [isEnabled, logEvent, subject]);

  if (isLoading) {
    return <PageLoader />;
  }
  if (!isEnabled(FEATURE_FLAGS.ON_GO) || !subject) {
    return <Navigate replace to={PATHS.ROOT} />;
  }

  return (
    <FullScreen footerFree justify='flex-start'>
      <PageTitle>W głowie</PageTitle>
      <TablesProvider dataSource='legacy_exercises'>
        <OnGoRouter subject={subject} />
      </TablesProvider>
    </FullScreen>
  );
};

export default OnGoPage;
